import actionTypes from "../../actions/actionTypes";
import updateObject from "../../../utils/updateObject";

const initialState = {
  fetching: true,
  data: {
    Info: null,
    Plan: null,
    Estimate: null,
  },
  error: null
};

const fetchInfo = (state, action) => {
  return updateObject(state, initialState);
}

const fetchInfoOk = (state, action) => {
  return updateObject(state, {
    fetching: false,
    error: null,
    data: action.data
  });
}

const fetchInfoError = (state, action) => {
  return updateObject(state, {
    fetching: false,
    data: {},
    error: action.error
  });
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.subscription.FETCH_INFO:
      return fetchInfo(state, action);
    case actionTypes.subscription.FETCH_INFO_OK:
      return fetchInfoOk(state, action);
    case actionTypes.subscription.FETCH_INFO_ERROR:
      return fetchInfoError(state, action);
    default:
      return state;
  }
}
